import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './SidedIconTrustBuilder.scss';
export const SidedIconTrustBuilder = ({ icon, title, description, }) => (React.createElement(Box, { className: s.sideIconContainer },
    icon,
    React.createElement(Box, { direction: "vertical" },
        React.createElement(Text, { weight: "bold", size: "tiny", className: s.title }, title),
        React.createElement(Text, { className: s.desc, weight: "thin", size: "tiny" }, description))));
//# sourceMappingURL=SidedIconTrustBuilder.js.map